module.exports = __webpack_public_path__ + "img/mobile.8fe8214d.svg";